<section class="proforma-invoice-dialog">
  <header>
    <h2>{{request.Regenerate ? 'Skapa ny PDF för självfaktura' : 'Skapa självfaktura'}}<span *ngIf="preview"> {{preview.Number}}</span></h2>
    <button mat-icon-button type="button" [disabled]="sending || editingCustomer" (click)="dialogRef.close()" aria-label="Stäng dialogen" matTooltip="Stäng"><mat-icon>close</mat-icon></button>
  </header>
  <div *ngIf="preview" class="preview-information">
    <p>Självfakturan sparas som dokument på underfakturan och skickas till {{preview.RecipientEmail}} när du godkänner.</p>
    <p *ngIf="request.Regenerate">Den nya PDF:en använder aktuella uppgifter och ersätter den tidigare. Vid lyckat utskick ersätts den aktiva transaktionsloggen och tidigare loggar inaktiveras.</p>
  </div>
  <mat-dialog-content>
    <div *ngIf="loading" class="loading" role="status"><mat-spinner diameter="36"></mat-spinner><p>Förbereder självfakturan</p></div>
    <iframe *ngIf="preview && pdfUrl" [src]="pdfUrl" title="Förhandsgranskning av självfaktura"></iframe>
  </mat-dialog-content>
  <footer>
    <div class="actions">
      <button *ngIf="preview && pdfUrl" mat-stroked-button type="button" [disabled]="loading" (click)="downloadPdf()">Ladda ner PDF</button>
      <button *ngIf="request.Invoice.RecipientOrganizationId" mat-stroked-button type="button" [disabled]="loading || sending || editingCustomer" (click)="editCustomer()">Redigera kunduppgifter</button>
      <button *ngIf="preview && !error" mat-flat-button color="accent" type="button" [disabled]="loading || sending || editingCustomer" (click)="approve()">{{sending ? 'Skapar och köar utskick…' : 'Godkänn och skicka'}}</button>
    </div>
    <p *ngIf="error" class="error" role="alert">{{error}}</p>
  </footer>
</section>
